import { Divider, Typography, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Attachments from '../../../components/Attachments/Attachments';
import CarouselContainerWithMetadata from '../../../components/Carousel/CarouselContainerWithMetadata';
import { MediaSlides } from '../../../components/Carousel/types';
import { IMediaAttachments } from './types';
import HorizontalWrapper from '../../../components/Details/HorizonticalWrapper';
import DetailsLinkedIcon from '../../../components/Details/DetailsLinkedIcon';
import MobileCarousel from '../../../components/Carousel/MobileCarousel';

interface IDetailsTekmirio{
  info: any[];
  basic_info: any[];
  file_info?: any[];
  media?: MediaSlides[];
  attachments?: IMediaAttachments[];
}

function DetailsTekmirio(props: IDetailsTekmirio) {
  const { t } = useTranslation();
  const {info, basic_info, file_info, media, attachments} = props;
  const matchesXSbreakpoint = useMediaQuery('(max-width:480px)');

  return (
    <>
      <DetailsLinkedIcon title={t('Βασικές Πληροφορίες')}
        detailsList={info}
      />
      <HorizontalWrapper
        details={basic_info}
      />
      {(media && media.length > 0) || (attachments && attachments.length > 0)
        ? <>
          <Typography mt={5} variant='h3'>
            {t('Συννημένα Αρχεία')}
          </Typography>
          <Divider sx={{ mt: 2, mb: 2 }} />
          {
            (media && media.length > 0) && matchesXSbreakpoint
              ? <MobileCarousel slides={media} media={file_info}
                fileInfo/>
              : (media && media.length > 0) &&  
              <CarouselContainerWithMetadata media={media} fileInfo={file_info}/>
          }
          <Divider sx={{ mt: 2, mb: 2 }} />
          {(attachments && attachments.length > 0) && <Attachments attachments={attachments}/>}
        </>
        : null

      }
    </>
  );
}

export default DetailsTekmirio;